import z from 'zod'

export const HOMEPAGE_VIEW_ANALYTICS = 'analytics'
export const HOMEPAGE_VIEW_SCORECARD = 'scorecard'

export const HomepageViews = [HOMEPAGE_VIEW_ANALYTICS, HOMEPAGE_VIEW_SCORECARD] as const

export type HomepageView = (typeof HomepageViews)[number]

export const isHomepageView = (view: string): view is HomepageView =>
  HomepageViews.includes(view as HomepageView)

export const HomepageViewSchema = z.enum(HomepageViews)

export const HomepageDefaultsSchema = z.object({
  agent: HomepageViewSchema.default(HOMEPAGE_VIEW_SCORECARD),
  admin: HomepageViewSchema.default(HOMEPAGE_VIEW_ANALYTICS),
})
export type HomepageDefaults = z.infer<typeof HomepageDefaultsSchema>

export const DEFAULT_HOMEPAGE_DEFAULTS: HomepageDefaults = {
  agent: HOMEPAGE_VIEW_SCORECARD,
  admin: HOMEPAGE_VIEW_ANALYTICS,
}

export const HomepageViewLabels: Record<HomepageView, string> = {
  analytics: 'Team Analytics',
  scorecard: 'My Scorecard',
}

export const HomepageViewDescriptions: Record<HomepageView, string> = {
  analytics:
    'Organization-wide metrics including conversation drivers, service quality trends, and aggregate performance data.',
  scorecard:
    'Personal quality scores, evaluation trends, and individual performance insights.',
}
